<mat-tab-group>

  <mat-tab label="{{ 'tabSwapHistory' | translate }}" bodyClass="mat-tab-hidden-overflow">
    <app-swap-history></app-swap-history>
  </mat-tab>

  <mat-tab label="{{ 'tabMyAccount' | translate }}" bodyClass="mat-tab-hidden-overflow">
    <app-my-account></app-my-account>
  </mat-tab>

  <!--  <mat-tab label="{{ 'tabAccountStatement' | translate }}">-->
  <!--  <app-account-statement></app-account-statement>-->
  <!--  </mat-tab>-->

</mat-tab-group>


